module.exports = __webpack_public_path__ + "trunking-top.svg?70a3d537071eb0f14743b488245de214";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backgrounds/trunking-top.svg
// module id = 74
// module chunks = 0